import { CostMethod } from "./CostMethod"
import { EnableModule } from "./EnableModule"

export const SettingsCostMethod = CostMethod
export const SettingsEnableModule = EnableModule



// WEBPACK FOOTER //
// ./src/inventory/sections/settings/index.ts